import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { SmartInquiryWidget } from './components/SmartInquiryWidget';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { GovernmentProjects } from './pages/GovernmentProjects';
import { Residential } from './pages/Residential';
import { Testimonials } from './pages/Testimonials';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/government-projects" element={<GovernmentProjects />} />
            <Route path="/residential" element={<Residential />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </main>
        <Footer />
        <SmartInquiryWidget />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
